import _ from "lodash";
import React from "react";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import I18nHOC from "UIComponents/I18nHOC";
import { goToRelativeRoute, openLinkInNewTab } from "modules/Services";
import { Button, EmptyState } from "@toddle-edu/ds-web";
import { PORTAL_URL_CN, PORTAL_URL_GLOBAL } from "Constants";
import moment from "moment-timezone";
import { Trans } from "react-i18next";

class MigrationInProgress extends React.Component {
  goToHomePage = () => {
    const { goToRelativeRoute } = this.props;
    goToRelativeRoute({ route: "/", type: "replace" });
  };

  goToRedirectUrl = url => {
    const { openLinkInNewTab } = this.props;
    openLinkInNewTab({ url });
  };

  render() {
    const { t } = this.props;

    const map = {
      IN_PROGRESS: {
        headerText: "common:migration_in_progress_header_text",
        subText: "common:migration_in_progress_sub_text",
        primaryButtonLabel: "common:go_to_homepage",
      },
      IN_PROGRESS_TO_US: {
        headerText: "common:migration_in_progress_us_header_text",
        subText: "common:migration_in_progress_us_sub_text",
        primaryButtonLabel: "common:go_to_homepage",
      },
      COMPLETED_TO_CN: {
        headerText: "common:migration_completed_cn_header_text",
        subText: "common:migration_completed_cn_sub_text",
        primaryButtonLabel: "common:go_to_china_url",
        url: PORTAL_URL_CN,
      },
      COMPLETED_TO_GLOBAL: {
        headerText: "common:migration_completed_global_header_text",
        subText: "common:migration_completed_global_sub_text",
        primaryButtonLabel: "common:go_to_global_url",
        url: PORTAL_URL_GLOBAL,
      },
    };

    const hours =
      moment(_.get(this.props, "location.state.willBeFinishedBy", null)).diff(
        moment(),
        "hours"
      ) || 0;

    const status = _.get(this.props, "location.state.status", "IN_PROGRESS");

    const errorText = _.get(
      this.props,
      "errorText",
      t(_.get(map, `${status}.headerText`, map.IN_PROGRESS.headerText))
    );
    const errorSubText = _.get(
      this.props,
      "errorSubText",
      <Trans i18nKey={_.get(map, `${status}.subText`, map.IN_PROGRESS.subText)}>
        <strong>{{ time: hours > 0 ? `${hours} hours` : "an hour" }}</strong>
        <a
          href={_.get(map, `${status}.url`)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ url: _.get(map, `${status}.url`) }}
        </a>
        <a
          href="https://www.toddleapp.cn/mobile-app-migration"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ here: "here" }}
        </a>
      </Trans>
    );

    const primaryButtonLabel = _.get(
      this.props,
      "primaryButtonLabel",
      t(
        _.get(
          map,
          `${status}.primaryButtonLabel`,
          map.IN_PROGRESS.primaryButtonLabel
        )
      )
    );

    const onRedirectButtonClick = _.get(
      this.props,
      "onRedirectButtonClick",
      () => {
        if (status === "COMPLETED_TO_CN") {
          this.goToRedirectUrl(PORTAL_URL_CN);
        } else if (status === "COMPLETED_TO_GLOBAL") {
          this.goToRedirectUrl(PORTAL_URL_GLOBAL);
        } else {
          this.goToHomePage();
        }
      }
    );

    return (
      !this.props.isLoading && (
        <EmptyState
          primaryButton={
            <Button onClick={onRedirectButtonClick}>
              {primaryButtonLabel}
            </Button>
          }
          size="large"
          title={errorText}
          subtitle={errorSubText}
        ></EmptyState>
      )
    );
  }
}

const mapActionCreators = {
  goToRelativeRoute,
  openLinkInNewTab,
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(null, mapActionCreators)
)(MigrationInProgress);
